import * as React from "react";
import { observer } from "mobx-react";
import { HotelWizardStateProps } from "../typings";

export const HotelHiddenSearchData = observer((props: HotelWizardStateProps) => {
  const hotelWizardState = props.hotelWizardState;

  return (
    <>
      {(hotelWizardState.isAddAFlightChecked || hotelWizardState.isAddACarChecked) && (
        <input type="hidden" name="packageType" data-testid="package-type" value={hotelWizardState.hotelPackageType} />
      )}
      {!hotelWizardState.hotelTabSelected && (
        <input type="hidden" name="sort" data-testid="vr-sort" value="vacationRental" />
      )}
    </>
  );
});
